module.exports = __webpack_public_path__ + "static/media/jQuery.85fceff3.png";